const { makeStyles } = require('@mui/styles');

export const useStyles = makeStyles(() => ({
    required: {
        color: '#D24444',
        fontSize: '18px',
        marginRight: '2px',
    },
    flexBox: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '8px',
    },
    failedValidation: {
        borderColor: '#D24444!important',
    },
    failText: {
        color: '#D24444',
        fontSize: '14px',
    },
}));
